let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Awvr")).then(() => parcelRequire('3j0s1'));